import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Progress, ListGroup, CardText, CardTitle, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import ApproveModal from "../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useReactToPrint } from "react-to-print";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import defaultImg from "../../assets/images/upload.png";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getPrintTemplate, resetPrintTemplateState } from "../../store/printTemplate/action";

import { resetClientState, getClient } from "../../store/client/action";
import { resetCompanyState, getCompany } from "../../store/company/action";
import { resetBranchState, getBranch } from "../../store/branch/action";
import { resetProductState, getProduct } from "../../store/product/action";
import { resetTicketState, getTicket } from "../../store/ticket/action";

import { resetTaskState, getTask, addNewTask, updateTask } from "../../store/task/action";
import { getUser, resetUserState } from "../../store/users/action";
import { getTaskCategory, resetTaskCategoryState } from "../../store/taskCategory/action";
import { resetTaskListState, getTaskList } from "../../store/taskList/action";
import ModalInputFile from "../../Components/ModalInputFile";
import { api } from "../../config";

import PrintDoc from "./PrintDoc";
import PrintDocBast from "./PrintDocBast";

const Task = () => {
  const printRef = useRef(null);
  const printRefBast = useRef(null);
  const [currentbyte, setCurrentByte] = useState(0);
  const [totalbyte, setTotalByte] = useState(0);
  const [percentbyte, setPercentByte] = useState(0);
  const [moduleFileItem, setModuleFileItem] = useState([]);
  const [fileNameItem, setFileNameItem] = useState([]);
  const [activeFileUpload, setActiveFileUpload] = useState({});
  const [isUploadFile, setIsFileUpload] = useState(false);
  const [deletedFileId, setDeletedFileId] = useState("");
  const [file, setFile] = useState([]);
  const [taskCategoryList, setTaskCategoryList] = useState([]);
  const [dataPrint, setDataPrint] = useState();
  const [info, setInfo] = useState([]);
  const [sikTemplateList, setSikTemplateList] = useState([]);
  const [datePrint, setDatePrint] = useState();
  const [placePrint, setPlacePrint] = useState();
  const [objekrint, setObjekPrint] = useState();
  const [sikPrint, setSikPrint] = useState();
  const [bastPrint, setBastPrint] = useState();
  const [prefixPrint, setPrefixPrint] = useState();
  const [infoPrint, setInfoPrint] = useState(null);
  const [infoPrintBast, setInfoPrintBast] = useState([]);
  const [seriPrint, setSeriPrint] = useState([]);
  const [seriObjekPrint, setSeriObjekPrint] = useState([]);

  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [modalPrintBast, setModalPrintBast] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [modalMedia, setModalMedia] = useState(false);
  const [taskFiles, setTaskFiles] = useState([]);
  const [authUser, setAuthUser] = useState();

  const dispatch = useDispatch();

  const { printTemplateLoading, printTemplates, products, productLoading, ticketLoading, tickets, taskCategoryLoading, taskCategories, branchLoading, branches, companyLoading, companies, tasks, isTaskCreated, isTaskSuccess, loading, error, users, userLoading, taskLists, taskListLoading, clientLoading, clients, isMediaDeleted, sikTemplates, bastTemplates } = useSelector((state) => ({
    tasks: state.Task.tasks,
    isTaskCreated: state.Task.isTaskCreated,
    isTaskSuccess: state.Task.isTaskSuccess,
    loading: state.Task.loading,
    error: state.Task.error,
    users: state.Users.users,
    userLoading: state.Users.loading,
    taskLists: state.TaskList.taskLists,
    taskListLoading: state.TaskList.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    taskCategories: state.TaskCategory.taskCategories,
    taskCategoryLoading: state.TaskCategory.loading,
    tickets: state.Ticket.tickets,
    ticketLoading: state.Ticket.loading,
    products: state.Product.products,
    productLoading: state.Product.loading,
    printTemplates: state.PrintTemplate.printTemplates,
    printTemplateLoading: state.PrintTemplate.loading,
    // sikTemplates: state.SikTemplate.sikTemplates,
    // bastTemplates: state.BastTemplate.bastTemplates,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [task, setTask] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [user, setUser] = useState(null);
  const [approveModal, setApproveModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [assignToList, setAssignToList] = useState([]);
  const [reportToList, setReportToList] = useState([]);
  const [taskListList, setTaskListList] = useState([]);
  const [ticketList, setTicketList] = useState([]);
  const [taskType, setTaskType] = useState(null);
  const [customItem, setCustomItem] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [canCreate, setCanCreate] = useState(false);
  const [productList, setProductList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [bastTemplateList, setBastTemplateList] = useState([]);
  const [printTemplateList, setPrintTemplateList] = useState([]);
  const ref = useRef(null);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);
  const [userEmployee, setUserEmployee] = useState(null);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  useEffect(() => {
    if (isUploadFile) {
      // setTotalByte(totalbyte);
      switch (true) {
        case currentbyte <= totalbyte:
          setPercentByte(Math.ceil((currentbyte / totalbyte) * 100));
          break;
        default:
          break;
      }
    }
  }, [isUploadFile, totalbyte, currentbyte, percentbyte, setTotalByte, setPercentByte, setIsFileUpload]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const reactToPrintContentBast = useCallback(() => {
    return printRefBast.current;
  }, [printRefBast]);

  const handleAfterPrintBast = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrintBast = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContentBast = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrintBast = useReactToPrint({
    content: reactToPrintContentBast,
    documentTitle: "BAST",
    onBeforeGetContent: handleOnBeforeGetContentBast,
    onBeforePrint: handleBeforePrintBast,
    onAfterPrint: handleAfterPrintBast,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (percentbyte === 100 && isUploadFile) {
      const fc = [];
      const fcId = [];

      if (fileNameItem && fileNameItem.length > 0) {
        fileNameItem.forEach((itm) => {
          fc.push(itm);
          fcId.push({ file_id: itm.id });
        });
      }

      if (activeFileUpload && activeFileUpload.id) {
        fc.push({
          file_id: activeFileUpload.id,
          originalname: activeFileUpload.filename,
          filename: activeFileUpload.filejadi,
          size: activeFileUpload.filesize,
        });
        setFileNameItem(fc);
        // setKirim(true);

        fcId.push({ file_id: activeFileUpload.id });
        const o = {};
        setActiveFileUpload(o);
      }
      setTimeout(() => {
        setTotalByte(0);
        setCurrentByte(0);
        setPercentByte(0);
        setIsFileUpload(false);
      }, 3000);
    }
  }, [percentbyte, isUploadFile, fileNameItem, activeFileUpload]);

  useEffect(() => {
    if (isMediaDeleted) {
      const object = fileNameItem.findIndex((obj) => obj.file_id === deletedFileId);
      if (object > -1) {
        fileNameItem.splice(object, 1);
      }
      const fc = fileNameItem;
      setFileNameItem(fc);
    }
  }, [isMediaDeleted, fileNameItem, deletedFileId]);

  const onStartFileUpload = useCallback(
    (filesize) => {
      setIsFileUpload(true);
      setTotalByte(filesize);
      // totalbyte = filesize;
      // document.querySelector('#_total').innerText =  `Total Bytes: ${totalbyte}`
    },
    [setTotalByte]
  );

  const onProgressFileUpload = useCallback(
    (total) => {
      setCurrentByte(total);
      // setPercentByte(Math.ceil((currentbyte / totalbyte) * 100));
    },
    [setCurrentByte]
  );

  const onEndFileUpload = useCallback(
    (data) => {
      const js = JSON.parse(data.data);
      setTotalByte(parseInt(js.filesize));
      // const id = js.id;
      // handleFile(id);
      setActiveFileUpload(js);
      document.querySelector("#fUpload").value = "";
    },
    [setActiveFileUpload]
  );

  // const initFile = useCallback(() => {
  //   const obj = JSON.parse(localStorage.getItem("authUser"));
  //   const allowedmime = [
  //     // "application/vnd.ms-excel",
  //     // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     // "application/msword",
  //     // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     // "application/pdf",
  //     "image/jpg",
  //     "image/jpeg",
  //     "image/png",
  //   ];

  //   const option = {
  //     idinput: "fUpload",
  //     userId: obj.data.id.toString(),
  //     clientId: obj?.data?.user_client ? obj?.data?.user_client.id.toString() : "",
  //     folder: "task",
  //     allowedmime: allowedmime,
  //     onStart: onStartFileUpload,
  //     onEnd: onEndFileUpload,
  //     onProgress: onProgressFileUpload,
  //   };

  //   Fileserver(option);
  // }, [onStartFileUpload, onEndFileUpload, onProgressFileUpload]);

  // const handleDeleteFiles = useCallback(
  //   (filesId) => {
  //     const object = fileNameItem.findIndex((obj) => obj.id === filesId);
  //     const object2 = file.findIndex((obj) => obj.id === filesId);

  //     if (object > -1) {
  //       dispatch(deleteFile({ id: filesId }));
  //       fileNameItem.splice(object, 1);
  //     }

  //     if (object2 > -1) {
  //       dispatch(deleteFile({ id: filesId }));
  //       file.splice(object, 1);
  //     }
  //   },
  //   [dispatch, file, fileNameItem]
  // );

  const statusActiveData = [
    {
      options: [
        { label: "In Progress", value: "1" },
        { label: "Completed", value: "2" },
      ],
    },
  ];

  // const onClickDeleteFile = (id) => {
  //   if (id) {
  //     setDeletedFileId(id);
  //     dispatch(onDeleteMedia(id));
  //   }
  // };

  const defaultdate = () => {
    return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const onClickDelete = (task) => {
    setTask(task);
    setDeleteModal(true);
  };

  const handleDeleteTask = () => {
    if (task) {
      // dispatch(onDeleteTask(task));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (task) => {
    setTask(task);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTasks = tasks;
      if (type !== "all") {
        filteredTasks = tasks.filter((task) => task.task_status.name === type);
      }
      setTaskList(filteredTasks);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`);
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId,
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId,
        });

        setAuthUser(obj);
        setUserEmployee(obj.data.employee);

        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
        handleGetUser(obj.data.companyId);
        handleGetBranch(obj.data.companyId);

        dispatch(resetPrintTemplateState());
        dispatch(getPrintTemplate());
        dispatch(resetTaskState());
        dispatch(getTask());
        dispatch(resetClientState());
        dispatch(getClient());
        dispatch(resetTaskCategoryState());
        dispatch(getTaskCategory());

        dispatch(resetTicketState());
        dispatch(getTicket({ status: 1 }));
        dispatch(resetTaskListState());
        dispatch(getTaskList());
      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    if (!isEmpty(tasks)) {
      setIsEdit(false);
      let filteredTasks = tasks;
      if (activeTypeTab !== "all") {
        filteredTasks = tasks.filter((task) => task.task_status.name === activeTypeTab);
      }
      setTaskList(filteredTasks);
    }
  }, [tasks]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(users)) {
      var data = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const taskListId = item.taskListId;
        const clientId = item.clientId;
        const position = item.user_position && item.user_position.name ? `, ${item.user_position.name}` : "";
        const client_name = item.user_client && item.user_client.name ? item.user_client.name : "Not set";
        var obj = {
          label: name + position + " - " + client_name,
          value: id,
          taskListId: taskListId,
          clientId: clientId,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);

      setReportToList(data);
      setAssignToList(data);
    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(printTemplates)) {
      var data = [];
      var opt = [];
      printTemplates.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const description = item.description;
        var obj = { label: name, value: id, description: description };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPrintTemplateList(data);
    }
  }, [printTemplates]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    var data = [];
    var opt = [];
    products.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (products.length > 0) {
      setProductList(data);
    }
  }, [products]);

  useEffect(() => {
    if (!isEmpty(taskCategories)) {
      var data = [];
      var opt = [];
      taskCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaskCategoryList(data);
    }
  }, [taskCategories]);

  useEffect(() => {
    if (!isEmpty(taskLists)) {
      var data = [];
      var opt = [];
      taskLists.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaskListList(data);
    }
  }, [taskLists]);

  useEffect(() => {
    if (!isEmpty(tickets)) {
      var data = [];
      var opt = [];
      tickets.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const ticketClient = item.ticket_client;
        const ticketCompany = item.ticket_company;
        var obj = {
          label: name,
          value: id,
          client: ticketClient,
          company: ticketCompany,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTicketList(data);
    }
  }, [tickets]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCompanyList([]);
      setBranchList([]);
      setProductList([]);
      setTaskType(null);
      setTaskFiles([]);
      setAssignToList([]);
      setReportToList([]);
      validation.resetForm();
      validation.setErrors({});
      // setTask(null);
      // setTicketList([]);
      // dispatch(resetUserState());
      // setFileNameItem([]);
    } else {
      setModal(true);
      // initFile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const togglePrint = useCallback(() => {
    if (modalPrint) {
      setModalPrint(false);
      setDatePrint();
      setPlacePrint();
      setObjekPrint();
      setPrefixPrint();
      validationSik.resetForm();
      validationSik.setErrors({});
    } else {
      setModalPrint(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalPrint]);

  const togglePrintBast = useCallback(() => {
    if (modalPrintBast) {
      setModalPrintBast(false);
      setDatePrint();
      setPlacePrint();
      setObjekPrint();
      validationBast.resetForm();
      validationBast.setErrors({});
    } else {
      setModalPrintBast(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalPrintBast]);

  const handleTaskClick = useCallback(
    (arg) => {
      const task = arg;

      let task_assignto = [];

      if (task.task_assign) {
        task.task_assign.forEach((item) => {
          const label = item.taska_user?.name;
          const id = item.taska_user?.id;
          var obj = { label: label, value: id, userId: id };
          task_assignto.push(obj);
        });
      }

      let task_reportto = [];

      if (task.task_report) {
        task.task_report.forEach((item) => {
          const label = item.taskr_user?.name;
          const id = item.taskr_user?.id;
          var obj = { label: label, value: id, userId: id };
          task_reportto.push(obj);
        });
      }

      let task_product = [];

      if (task.task_product) {
        task.task_product.forEach((item) => {
          const label = item.task_product_product?.name;
          const id = item.task_product_product?.id;
          var obj = { label: label, value: id };
          task_product.push(obj);
        });
      }

      if (task.task_type === "Template") {
        setTaskType("Template");
      } else if (task.task_type === "Ticket") {
        setTaskType("Ticket");
      } else {
        setTaskType("Custom");
      }

      let files = [];

      if (task.task_file.length > 0) {
        task.task_file.forEach((element) => {
          files.push({
            filename: element.filename,
          });
        });
      }

      setTaskFiles(files);

      let cusItm = [];

      if (task.task_detail.length > 0) {
        task.task_detail.forEach((el) => {
          if (el) {
            cusItm.push({ name: el.name, product: el.product, description: el.description });
          }
        });
      }

      setCustomItem(cusItm);

      // 2024/01/26 12:00 to 2024/01/26 12:00

      setTask({
        id: task.id,
        name: task.name,
        description: task.description,
        allocation: task.allocation,
        taskat: `${moment(task.startat).format("YYYY/MM/DD hh:mm")} to ${moment(task.endat).format("YYYY/MM/DD hh:mm")}`,
        client: task.task_client && {
          label: task.task_client ? task.task_client.name : "",
          value: task.task_client ? task.task_client.id : "",
        },
        company: task.task_company && {
          label: task.task_company ? task.task_company.name : "",
          value: task.task_company ? task.task_company.id : "",
        },
        branch: task.task_branch && {
          label: task.task_branch ? task.task_branch.name : "",
          value: task.task_branch ? task.task_branch.id : "",
        },
        ticket: task.task_ticket && {
          label: task.task_ticket ? task.task_ticket.name : "",
          value: task.task_ticket ? task.task_ticket.id : "",
        },
        taskList: task.task_task_list && {
          label: task.task_task_list ? task.task_task_list.name : "",
          value: task.task_task_list ? task.task_task_list.id : "",
        },
        taskCategory: task.task_category && {
          label: task.task_category ? task.task_category.name : "",
          value: task.task_category ? task.task_category.id : "",
        },
        assignto: task_assignto,
        reportto: task_reportto,
        product: task_product ?? [],
        task_type: task.task_type && {
          label: task.task_type ? task.task_type : "",
          value: task.task_type ? task.task_type : "",
        },
      });

      handleGetCompany(task.task_client ? task.task_client.id : "");
      handleGetBranch(task.task_company ? task.task_company.id : "");
      handleGetProduct(task.task_company ? task.task_company.id : "");
      handleGetUser(task.task_client ? task.task_client.id : "");

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]
  );

  const handleSelectFile = (file) => {
    setTaskFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = taskFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setTaskFiles(newState);
    } else {
      const index = taskFiles.findIndex((fl) => fl.filename === file.filename);
      setTaskFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
      // setOtherDocImg(val =>
      //   val.filter(fl => {
      //     return fl.id !== file.id;
      //   }),
      // );
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tugas",
        accessor: "name",
        filterable: true,
        Cell: (cell) => (
          <>
            <div className="mb-1">
              {userType === "admin" || userType === "client" || userType === "company" ? (
                <Link to={"/task-detail/" + cell.row.original.id} className="fw-semibold">
                  {cell.value}
                </Link>
              ) : userRole && userRole.split(",").indexOf("viewTaskDetail") !== -1 ? (
                <Link to={"/task-detail/" + cell.row.original.id} className="fw-semibold">
                  {cell.value}
                </Link>
              ) : (
                <>{cell.value}</>
              )}
            </div>
            <div className="mt-lg-0">
              <p className="text-muted mb-1">
                Task is allocated for
                <span className="badge text-uppercase fs-12 badge-soft-info">{cell.row.original.allocation} person</span>
                Assigned To:
              </p>
              <div className="avatar-group">
                {(cell.row.original.task_assign || []).map((element) => {
                  if (element.taska_user.image) {
                    return (
                      <Fragment key={element.id}>
                        <Link to="#" className="avatar-group-item" id={"img-" + element.id}>
                          <img src={`${api.MEDIA_URL}/media/${element.taska_user.image}-50-50`} alt="" className="rounded-circle avatar-xs" />
                        </Link>
                        <UncontrolledTooltip placement="top" target={"img-" + element.id}>
                          {element.taska_user.name}
                        </UncontrolledTooltip>
                      </Fragment>
                    );
                  } else {
                    return (
                      <Fragment key={element.id}>
                        <Link className="avatar-group-item" id={"img-" + element.id}>
                          <div className="avatar-xs">
                            <div className="avatar-title rounded-circle bg-light text-primary">{element.taska_user.name.charAt(0).toUpperCase()}</div>
                          </div>
                        </Link>
                        <UncontrolledTooltip placement="top" target={"img-" + element.id}>
                          {element.taska_user.name}
                        </UncontrolledTooltip>
                      </Fragment>
                    );
                  }
                })}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Tipe",
        filterable: true,
        accessor: "task_type",
        Cell: (data) => {
          return (
            <>
              <p className="mb-2">{data.row.original.task_category && data.row.original.task_category.name}</p>
              <span className="badge text-uppercase badge-soft-info">{data.row.original.task_type}</span>
            </>
          );
        },
      },
      {
        Header: "Prioritas",
        accessor: "priority",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "Medium":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "Low":
              return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
            case "High":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
      {
        Header: "Periode Tugas",
        accessor: "endat",
        filterable: true,
        Cell: (data) => (
          <>
            {handleValidDate(data.row.original.endat)}
            <small>{handleValidTime(data.row.original.endat)}</small>
          </>
        ),
      },
      {
        Header: "Rating",
        accessor: "rating",
        filterable: true,
        Cell: (data) => {
          if (data.row.original.rating) {
            return (
              <span className="badge bg-light text-body fs-12 fw-medium">
                <i className="mdi mdi-star text-warning me-1"></i>
                {data.row.original.rating}
              </span>
            );
          } else return <span></span>;
        },
      },
      {
        Header: "Status",
        accessor: "task_status.name",
        filterable: true,
        Cell: (cell) => {
          return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
        },
      },
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {userType === "admin" || userType === "client" || userType === "company" ? (
                <Link to={"/task-detail/" + cellProps.row.original.id} className="btn-icon btn btn-sm btn-light">
                  <i className="ri-eye-line fs-15"></i>
                </Link>
              ) : userRole && userRole.split(",").indexOf("viewTaskDetail") !== -1 ? (
                <Link to={"/task-detail/" + cellProps.row.original.id} className="btn-icon btn btn-sm btn-light">
                  <i className="ri-eye-line fs-15"></i>
                </Link>
              ) : (
                <>
                  {cellProps.value} -<small className="ri-eye-line fs-15">{cellProps.row.original.task_department ? cellProps.row.original.task_department.name : ""}</small>
                </>
              )}

              {cellProps.row.original.statusId === 1 && (
                <Link
                  to="#"
                  className={userType === "admin" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateTask") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                  onClick={() => {
                    handleTaskClick(cellProps.row.original);
                  }}
                >
                  <i className="ri-edit-2-line fs-15"></i>
                </Link>
              )}
            </div>
          );
        },
      },
    ],
    [handleTaskClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: taskList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveTask = () => {
    if (task) {
      task.setApprove = true;
      // dispatch(onUpdateTask(task));
      setApproveModal(false);
    }
  };

  const validationSik = useFormik({
    enableReinitialize: true,
    initialValues: {
      prefixDoc: "",
      sikTemplate: "",
      document_prefix: "",
      document_to: "",
      document_signed: "",
    },
    validationSchema: Yup.object({
      sikTemplate: Yup.object().required("Please Select Template").nullable(true),
    }),
    onSubmit: (values) => {
      setInfoPrint({
        data: info,
        sik: values.sikTemplate,
        prefix: values.prefixDoc,
        employee: userEmployee,
        auth: authUser,
        to: authUser.data.user.user_position ? authUser.data.name + " - " + authUser.data.user.user_position.name : authUser.data.name,
      });
      let dataPostSik = {
        id: info.id,
        taskPrintTemplateId: values.sikTemplate.value,
        document_prefix: values.prefixDoc,
        document_to: values.to,
        document_signed: authUser.data.user.user_position ? authUser.data.name + " - " + authUser.data.user.user_position.name : authUser.data.name,
      };
      dispatch(updateTask(dataPostSik));
      handlePrint();
      togglePrint();
    },
  });

  const validationBast = useFormik({
    enableReinitialize: true,
    initialValues: {
      bastTemplate: "",
      prefixDoc: "",
      document_prefix: "",
      document_to: "",
      document_signed: "",
    },
    validationSchema: Yup.object({
      bastTemplate: Yup.object().required("Please Select Template").nullable(true),
    }),
    onSubmit: (values) => {
      setInfoPrintBast({
        data: info,
        bast: values.bastTemplate,
        prefix: values.prefixDoc,
        employee: userEmployee,
        auth: authUser,
        to: authUser.data.user.user_position ? authUser.data.name + " - " + authUser.data.user.user_position.name : authUser.data.name,
      });
      let dataPostBast = {
        id: info.id,
        taskPrintTemplateId: values.sikTemplate.value,
        document_prefix: values.prefixDoc,
        document_to: values.to,
        document_signed: authUser.data.user.user_position ? authUser.data.name + " - " + authUser.data.user.user_position.name : authUser.data.name,
      };
      dispatch(updateTask(dataPostBast));
      handlePrintBast();
      togglePrintBast();
    },
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (task && task.name) ?? "",
      ticket: (task && task.ticket) ?? "",
      description: (task && task.description) ?? "",
      taskat: task && task.taskat,
      task_type: (task && task.task_type) ?? "",
      priority: (task && task.priority) || { label: "Low", value: "Low" },
      assignto: task && task.assignto,
      reportto: task && task.reportto,
      // taskList: (task && task.taskList) || { value: "" },
      taskList: (task && task.taskList) ?? "",
      client: (task && task.client) || clientSelected,
      company: (task && task.company) || companySelected,
      branch: (task && task.branch) ?? "",
      product: (task && task.product) || [],
      taskCategory: (task && task.taskCategory) ?? "",
      allocation: (task && task.allocation) ?? "",
    },
    validationSchema: Yup.object({
      taskat: Yup.string().required("Please Enter Task Date").nullable(true),
      task_type: Yup.object().required("Please Select Type").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      let datearr = values.taskat.split(" to ");
      let startat = datearr[0] && datearr[0];
      let endat = datearr[1] ? datearr[1] : datearr[0] && datearr[0];

      // dispatch(getTaskLoading());
      if (isEdit) {
        let updateSubmit = {
          id: task.id,
          startat: startat,
          endat: endat,
          name: values.name,
          description: values.description,
          task_type: values.task_type.value,
          priority: values.priority.value,
          assignto: values.assignto,
          reportto: values.reportto,
          taskListId: values.taskList.value,
          custom_task: customItem,
          statusId: 1,
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          product: values.product,
          // file: JSON.stringify(fileNameItem),
          taskCategoryId: values.taskCategory.value,
          allocation: values.allocation,
          files: taskFiles.length > 0 ? taskFiles : [],
        };
        if (values.ticket !== "") {
          updateSubmit = {
            ...updateSubmit,
            ticketId: values.ticket.value,
          };
        }

        dispatch(updateTask(updateSubmit));
        validation.resetForm();
      } else {
        let newTask = {
          startat: startat,
          endat: endat,
          name: values.name,
          description: values.description,
          task_type: values.task_type.value,
          priority: values.priority.value,
          assignto: values.assignto,
          reportto: values.reportto,
          taskListId: values.taskList.value,
          custom_task: customItem,
          statusId: 1,
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          product: values.product,
          // file: JSON.stringify(fileNameItem),
          taskCategoryId: values.taskCategory.value,
          allocation: values.allocation,
          files: taskFiles.length > 0 ? taskFiles : [],
        };

        if (values.ticket !== "") {
          newTask = {
            ...newTask,
            ticketId: values.ticket.value,
          };
        }

        dispatch(addNewTask(newTask));
        validation.resetForm();
      }
      toggle();
    },
  });

  function handleCustomItemAdd() {
    let fc = [];
    if (customItem && customItem) {
      customItem.forEach((element) => {
        fc.push(element);
      });
    }
    fc.push({
      name: "",
      product: [],
      description: "",
    });
    setCustomItem(fc);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    // dispatch(onGetTasks(param));
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = (id) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: id }));
  };

  const handleGetProduct = (id) => {
    dispatch(resetProductState());
    dispatch(getProduct({ companyId: id }));
  };

  const handleGetUser = (id) => {
    dispatch(resetUserState());
    dispatch(getUser({ type: "Task", clientId: id }));
  };

  const resetList = () => {
    setCompanyList([]);
    validation.setFieldValue("company", "");
    setBranchList([]);
    validation.setFieldValue("branch", "");
  };

  document.title = "Task | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={task && task.task_user ? task.task_user.user_name : ""} show={approveModal} onApproveClick={handleApproveTask} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTask} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Task" pageTitle="Task" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Penugasan&nbsp;
                    {isLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createTask") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setIsEdit(false);
                        toggle();
                      }}
                    >
                      <i className="ri-todo-line me-1 align-bottom fs-14"></i>TAMBAH TUGAS
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-todo-line me-1 align-bottom fs-14"></i>All Task
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "Active");
                        }}
                        href="#"
                      >
                        <i className="ri-time-line me-1 align-bottom fs-14"></i>In Progress
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "Inactive");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>Completed
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>

                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />{" "}
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(obj, str) => {
                                  setFilterDate(str);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                                id="idStatus"
                              ></Select>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader
                    className="bg-light p-3"
                    toggle={() => {
                      toggle();
                    }}
                  >
                    {!!isEdit ? "Edit Tugas" : "Tambah Tugas"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Row>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;{" "}
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setReportToList([]);
                                setProductList([]);
                                setAssignToList([]);
                                setCompanyList([]);
                                setBranchList([]);
                                validation.setFieldValue("assignto", []);
                                validation.setFieldValue("reportto", []);
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("branch", "");
                                validation.setFieldValue("product", []);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                                handleGetUser(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;{" "}
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                setBranchList([]);
                                setProductList([]);
                                validation.setFieldValue("branch", "");
                                validation.setFieldValue("company", e);
                                handleGetBranch(e.value);
                                handleGetProduct(e.value);
                              }}
                              options={companyList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="branch-field" className="form-label">
                              Cabang&nbsp;
                              {branchLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Select Cabang"
                              isDisabled={branchList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("branch", e);
                                // handleGetCompany(e.value);
                              }}
                              options={branchList}
                            ></Select>
                            {validation.touched.branch && validation.errors.branch ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.branch}
                              </small>
                            ) : null}
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label htmlFor="task_type" className="form-label">
                              Tipe Penugasan
                            </Label>
                            <Select
                              name="task_type"
                              placeholder="Select Type"
                              value={validation.values.task_type}
                              onChange={(e) => {
                                setCustomItem([]);
                                validation.setFieldValue("name", "");
                                validation.setFieldValue("description", "");
                                validation.setFieldValue("taskList", "");
                                validation.setFieldValue("custom_task", []);
                                validation.setFieldValue("ticket", "");
                                validation.setFieldValue("task_type", e);
                                setTaskType(e.value);
                              }}
                              options={[
                                {
                                  options: [
                                    { label: "Templat", value: "Template" },
                                    { label: "Permintaan Pekerjaan", value: "Ticket" },
                                    { label: "Kustom", value: "Custom" },
                                  ],
                                },
                              ]}
                            ></Select>
                            {validation.touched.task_type && validation.errors.task_type ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.task_type}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="password-field" className="form-label">
                              Kategori Tugas&nbsp;
                              {taskCategoryLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="taskCategory"
                              value={validation.values.taskCategory}
                              placeholder="Select Task Category"
                              // isDisabled={type==="taskCategory"?true:false}
                              onChange={(e) => {
                                validation.setFieldValue("taskCategory", e);
                              }}
                              options={taskCategoryList}
                            ></Select>
                          </div>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="allocation-field" className="form-label">
                                  Alokasi Karyawan
                                </Label>
                                <Input name="allocation" id="allocation-field" className="form-control" placeholder="Allocation" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.allocation} invalid={validation.touched.allocation && validation.errors.allocation ? true : false} />
                                {validation.touched.allocation && validation.errors.allocation ? <FormFeedback type="invalid">{validation.errors.allocation}</FormFeedback> : null}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="priority" className="form-label">
                                  Prioritas
                                </Label>
                                <Select
                                  name="priority"
                                  placeholder=""
                                  value={validation.values.priority}
                                  onChange={(e) => {
                                    validation.setFieldValue("priority", e);
                                  }}
                                  options={[
                                    {
                                      options: [
                                        { label: "High", value: "High" },
                                        { label: "Medium", value: "Medium" },
                                        { label: "Low", value: "Low" },
                                      ],
                                    },
                                  ]}
                                ></Select>
                                {validation.touched.priority && validation.errors.priority ? (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.priority}
                                  </small>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label htmlFor="assignto" className="form-label">
                              Assign To&nbsp;
                              {userLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="assignto"
                              value={validation.values.assignto}
                              placeholder="Select User"
                              isMulti
                              onChange={(opt, { option }) => {
                                let newOpts = opt;
                                if (option && option.value === "all") {
                                  let filteredOptions = clone(assignToList);
                                  filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                  newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                }
                                validation.setFieldValue("assignto", newOpts);
                              }}
                              options={assignToList}
                              noOptionsMessage={(e) => "Type User to get option"}
                              invalid={validation.touched.assignto && validation.errors.assignto ? true : false}
                            ></Select>
                            {validation.touched.assignto && validation.errors.assignto ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.assignto}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="reportto" className="form-label">
                              Report To&nbsp;
                              {userLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="reportto"
                              value={validation.values.reportto}
                              placeholder="Select User"
                              isMulti
                              onChange={(opt, { option }) => {
                                let newOpts = opt;
                                if (option && option.value === "all") {
                                  let filteredOptions = clone(reportToList);
                                  filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                  newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                }
                                validation.setFieldValue("reportto", newOpts);
                              }}
                              options={reportToList}
                              noOptionsMessage={(e) => "Type User to get option"}
                              invalid={validation.touched.reportto && validation.errors.reportto ? true : false}
                            ></Select>
                            {validation.touched.reportto && validation.errors.reportto ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.reportto}
                              </small>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="taskat-field" className="form-label">
                              Periode Penugasan
                            </Label>
                            <Flatpickr
                              name="taskat"
                              className="form-control"
                              id="taskat"
                              placeholder="Select Task Range Date"
                              value={validation.values.taskat}
                              options={{
                                enableTime: true,
                                time_24hr: true,
                                mode: "range",
                                dateFormat: "Y/m/d H:i",
                              }}
                              onChange={(obj, str) => {
                                validation.setFieldValue("taskat", str);
                              }}
                            />
                            {validation.touched.taskat && validation.errors.taskat ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.taskat}
                              </small>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <div className="col-lg-12">
                        {taskType === "Ticket" && (
                          <div className="mb-3">
                            <Label htmlFor="ticket-field" className="form-label">
                              Permintaan Pekerjaan&nbsp;
                              {ticketLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="ticket"
                              placeholder="Select Ticket"
                              value={validation.values.ticket}
                              onChange={(e) => {
                                const valueClient = {
                                  label: e.client.name,
                                  value: e.client.id,
                                };
                                const valueCompany = {
                                  label: e.company.name,
                                  value: e.company.id,
                                };
                                validation.setFieldValue("ticket", e);
                                validation.setFieldValue("client", valueClient);
                                validation.setFieldValue("company", valueCompany);
                                handleGetBranch(e.company.id);
                              }}
                              options={ticketList}
                            ></Select>
                          </div>
                        )}
                        {(taskType === "Template" || taskType === "Ticket") && (
                          <div className="mb-3 col-lg-12">
                            <Label htmlFor="taskList-field" className="form-label">
                              Templat Penugasan&nbsp;
                              {taskListLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="taskList"
                              placeholder="Select Task List"
                              value={validation.values.taskList}
                              onChange={(e) => {
                                validation.setFieldValue("taskList", e);
                              }}
                              options={taskListList}
                            ></Select>
                          </div>
                        )}

                        {taskType === "Custom" && (
                          <div>
                            <div className="mb-3 col-lg-12">
                              <Label htmlFor="name-field" className="form-label">
                                Task Title
                              </Label>
                              <Input name="name" id="name-field" className="form-control" placeholder="Task Name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                              {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-12">
                              <Label htmlFor="description-field" className="form-label">
                                Description
                              </Label>
                              <Input name="description" id="description-field" rows="4" className="form-control" placeholder="Enter Task Description" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="education" className="form-label">
                                Sub Task{" "}
                              </Label>
                              <button
                                type="button"
                                className="btn ms-3 btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  handleCustomItemAdd();
                                }}
                              >
                                <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Add Sub Task
                              </button>
                            </div>
                          </div>
                        )}
                        {taskType === "Custom" &&
                          customItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="row">
                                  <div className="mb-3 col-md-12">
                                    <Input
                                      name={`customItem.${i}.name`}
                                      className="form-control"
                                      placeholder="Task title"
                                      type="text"
                                      value={customItem[i].name ?? ""}
                                      onChange={(e) => {
                                        validation.setFieldValue(`customItem.${i}.name`, e.target.value);
                                        customItem[i].name = e.target.value;
                                      }}
                                      onBlur={validation.handleBlur}
                                    />
                                  </div>
                                  <div className="mb-3">
                                    <Label htmlFor="password-field" className="form-label">
                                      Product&nbsp;
                                      {productLoading ? (
                                        <Spinner color="primary" size="sm">
                                          Loading...
                                        </Spinner>
                                      ) : (
                                        ""
                                      )}
                                    </Label>
                                    <Select
                                      name={`customItem.${i}.product`}
                                      value={customItem[i].product}
                                      placeholder="Select Product"
                                      isMulti
                                      isDisabled={productList.length > 0 ? false : true}
                                      onChange={(opt, { option }) => {
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions = clone(productList);
                                          filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                          newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                        }
                                        customItem[i].product = newOpts;
                                        validation.setFieldValue(`customItem.${i}.product`, newOpts);
                                      }}
                                      noOptionsMessage={(e) => "Type Product to get option"}
                                      options={productList}
                                    ></Select>
                                  </div>
                                  <div className="mb-3 col-md-12">
                                    <Input
                                      name={`customItem.${i}.description`}
                                      className="form-control"
                                      placeholder="Task description"
                                      rows={4}
                                      type="textarea"
                                      value={customItem[i].description ?? ""}
                                      onChange={(e) => {
                                        validation.setFieldValue(`customItem.${i}.description`, e.target.value);
                                        customItem[i].description = e.target.value;
                                      }}
                                      onBlur={validation.handleBlur}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        <div className="col-lg-12 mb-3">
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="taskFiles" className="form-label me-3">
                              File Penugasan
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                // setMediaType("other");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {taskFiles.map((taskFile, i) => {
                            if (taskFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={taskFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${taskFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{taskFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          handleDeleteFile(taskFile);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Penugasan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModal" isOpen={modalPrint} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={togglePrint}>
                    {"Setting Print SIK"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationSik.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              SIK Template
                            </Label>
                            <Select
                              name="sikTemplate"
                              value={validationSik.values.sikTemplate}
                              validate={{ required: { value: true } }}
                              placeholder="Select Template"
                              onChange={(e) => {
                                validationSik.setFieldValue("sikTemplate", e);
                                setSikPrint(e.data);
                              }}
                              options={printTemplateList}
                              invalid={validationSik.touched.sikTemplate && validationSik.errors.sikTemplate ? true : false}
                            ></Select>
                            {validationSik.touched.sikTemplate && validationSik.errors.sikTemplate ? (
                              <p className="text-danger small mt-1" type="invalid">
                                {validationSik.errors.sikTemplate}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Prefix Document
                            </Label>
                            <Input name="prefixDoc" id="prefixDoc-field" className="form-control" placeholder="Enter Prefix" type="text" validate={{ required: { value: true } }} onChange={validationSik.handleChange} onBlur={validationSik.handleBlur} value={validationSik.prefixDoc} invalid={validationSik.touched.prefixDoc && validationSik.errors.prefixDoc ? true : false} />
                            {validationSik.touched.prefixDoc && validationSik.errors.prefixDoc ? <FormFeedback type="invalid">{validationSik.errors.prefixDoc}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              To
                            </Label>
                            <Input name="to" id="to-field" className="form-control" placeholder="Enter To" type="text" validate={{ required: { value: true } }} onChange={validationSik.handleChange} onBlur={validationSik.handleBlur} value={validationSik.to} invalid={validationSik.touched.to && validationSik.errors.to ? true : false} />
                            {validationSik.touched.to && validationSik.errors.to ? <FormFeedback type="invalid">{validationSik.errors.to}</FormFeedback> : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            togglePrint();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Apply"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModal" isOpen={modalPrintBast} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={togglePrintBast}>
                    {"Setting Print BAST"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationBast.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              BAST Template
                            </Label>
                            <Select
                              name="bastTemplate"
                              value={validationBast.values.bastTemplate}
                              validate={{ required: { value: true } }}
                              placeholder="Select Template"
                              onChange={(e) => {
                                validationBast.setFieldValue("bastTemplate", e);
                              }}
                              options={printTemplateList}
                              invalid={validationBast.touched.bastTemplate && validationBast.errors.bastTemplate ? true : false}
                            ></Select>
                            {validationBast.touched.bastTemplate && validationBast.errors.bastTemplate ? (
                              <p className="text-danger small mt-1" type="invalid">
                                {validationBast.errors.bastTemplate}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Prefix Document
                            </Label>
                            <Input name="prefixDoc" id="prefixDoc-field" className="form-control" placeholder="Enter Prefix" type="text" validate={{ required: { value: true } }} onChange={validationBast.handleChange} onBlur={validationBast.handleBlur} value={validationBast.prefixDoc} invalid={validationBast.touched.prefixDoc && validationBast.errors.prefixDoc ? true : false} />
                            {validationBast.touched.prefixDoc && validationBast.errors.prefixDoc ? <FormFeedback type="invalid">{validationBast.errors.prefixDoc}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              To
                            </Label>
                            <Input name="to" id="to-field" className="form-control" placeholder="Enter To" type="text" validate={{ required: { value: true } }} onChange={validationBast.handleChange} onBlur={validationBast.handleBlur} value={validationBast.to} invalid={validationBast.touched.to && validationBast.errors.to ? true : false} />
                            {validationBast.touched.to && validationBast.errors.to ? <FormFeedback type="invalid">{validationBast.errors.to}</FormFeedback> : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            togglePrintBast();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Apply"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {infoPrint && <PrintDoc innerRef={printRef} item={infoPrint} />}
        {infoPrintBast && <PrintDocBast innerRef={printRefBast} item={infoPrintBast} />}
      </Container>
    </div>
  );
};

export default Task;
